export const bundleScript = ()=>{
    const bundleContainer = document.querySelector('.product-bundle-selector');

    if(bundleContainer){
        const bundleItems = bundleContainer.querySelectorAll('.product-bundle-selector__list__item');
        const bundleIds = []
        const addToCartButton = document.querySelector('button[name="add"]');

        const bundlePrice = document.querySelector('[data-bundle-price]')
        const bundlePriceDiscount = document.querySelector('[data-bundle-price-discount]')
        const bundleDiscount = bundleContainer.dataset.discount;

        const cartCurrencySymbol = bundleContainer ? bundleContainer.dataset.cartCurrency : null;
        const shopMoney = bundleContainer ? bundleContainer.dataset.shopMoney : null;

        const bundleProductsInfoJson = document.querySelector('#BundleProductsData');
        const bundleProductsInfo = bundleProductsInfoJson ? JSON.parse(bundleProductsInfoJson.textContent) : null;

        const images = document.querySelectorAll('[data-product-bundle-img]')

        let matchingProducts = [];
        
        bundleContainer.addEventListener('product:variant:changed:custom',()=>{
            setTimeout(()=>{
                checkProductAvailability()
                setTimeout(()=>{
                    updateInfos()
                },200)
            },500)
        })

        setTimeout(()=>{
            checkProductAvailability(true)
            setTimeout(()=>{
                updateInfos()
            },200)
        },500)

        if(addToCartButton){
            addToCartButton.addEventListener('click',(e)=>{
                const loader = addToCartButton.querySelector('.spinner');
                const text = addToCartButton.querySelector('span');
                loader.classList.remove('hide');
                text.classList.add('hide');
                e.preventDefault();
                const items = []
                matchingProducts.forEach((variant)=>{
                    const existingItem = items.find((it)=>it.id == variant.id);
                    if(existingItem){
                        existingItem.quantity += 1
                    } else{
                        let item = {
                            id: variant.id,
                            quantity: 1
                        }
                        items.push(item)
                    }
                })
                
                fetch('/cart/add.js', {
                    body:JSON.stringify({items: items}),
                    credentials: 'same-origin',
                    headers: {
                      'Content-Type': 'application/json',
                      'X-Requested-With':'xmlhttprequest' /* XMLHttpRequest is ok too, it's case insensitive */
                    },
                    method: 'POST'
                }).then(()=>{
                    // document.documentElement.dispatchEvent(new CustomEvent('cart:updated', {
                    //     bubbles: true,
                    //     detail: {
                    //       cart: parsedState
                    //     }
                    // }));
                    loader.classList.add('hide');
                    text.classList.remove('hide');
                    window.location = window.LoessTheme.routes.cart_url;
                }).catch((e)=>{
                    console.log(e);
                    loader.classList.add('hide');
                    text.classList.remove('hide');
                })
            })
        }

        bundleItems.forEach((item,index)=>{
            bundleIds.push(null)
            const select = item.querySelector('select');
            const visibleItems = item.querySelectorAll('.product-selected-item')
            if(select){
                bundleIds[index] = select.value;
                select.addEventListener('change',(e)=>{
                    const val = e.target.value;
                    bundleIds[index] = val;
                    visibleItems.forEach((el)=>{
                        const productId = el.dataset.productId
                        if(productId == val){
                            el.classList.add('selected')
                        } else{
                            el.classList.remove('selected')
                        }
                    })
                    checkProductAvailability()
                    setTimeout(()=>{
                        updateInfos()
                    },300)
                })
            }
        })

        function checkProductAvailability(first){
            const selectedValues = getVariantSelection()
            matchingProducts = []
            const productsNotAvailable = []
            
            resetSelectOptions()

            bundleProductsInfo.forEach((product)=>{
                const variants = product.variants
                let matchingVariant = null
                variants.forEach((variant)=>{
                    let matchingAllValues = true;
                    selectedValues.forEach((val)=>{
                        const productOptionIndex = product.options.findIndex((op)=>op == val.name);
                        const variantOption = variant.options[productOptionIndex]
                        if(productOptionIndex >= 0 && variantOption !== val.value){
                            matchingAllValues = false;
                        }
                    })
                    if(matchingAllValues && !matchingVariant){
                        matchingVariant = variant
                    }
                })
                if(!matchingVariant || !matchingVariant.available){
                    productsNotAvailable.push(product.id);
                }
            })

            productsNotAvailable.forEach((p)=>{
                const options = document.querySelectorAll(`option[value="${p}"]`);
                if(options){
                    options.forEach((op)=>{
                        op.setAttribute('disabled','')
                    })
                }
                bundleItems.forEach((item)=>{
                    const select = item.querySelector('select');
                    if(select.value == String(p)){
                        const visibleItems = item.querySelectorAll('.product-selected-item')
                        visibleItems.forEach((el)=>{
                            el.classList.remove('selected');
                        })
                        const altOption = item.querySelector(`option:not([value="${p}"])`)
                        if(altOption && first){
                            select.value = null
                            const currentBundleId = bundleIds.indexOf(String(p));
                            if( currentBundleId !== -1){
                                bundleIds[currentBundleId] = altOption.value;
                                select.value = altOption.value
                            }
                            visibleItems.forEach((el)=>{
                                if(el.dataset.productId == altOption.value){
                                    el.classList.add('selected');
                                }
                            })
                        } else{
                            select.value = null
                            const currentBundleId = bundleIds.indexOf(String(p));
                            if( currentBundleId !== -1){
                                bundleIds[currentBundleId] = null;
                            }
                            const options = select.querySelectorAll(`option`)
                            options.forEach((op)=>{
                                op.removeAttribute('selected');
                            })
                            visibleItems.forEach((el)=>{
                                if(el.dataset.productId =='empty'){
                                    el.classList.add('selected');
                                }
                            })
                        }
                    }
                })
            })
            switchAddToCartAvailable()
        }

        function switchAddToCartAvailable(){
            if(bundleIds.every((id)=>id!==null)){
                addToCartButton.removeAttribute('disabled')
            } else{
                addToCartButton.setAttribute('disabled','')
            }
        }
        
        function resetSelectOptions(){
            bundleItems.forEach((item,index)=>{
                const select = item.querySelector('select');
                if(select){
                    const options = select.querySelectorAll('option');
                    options.forEach((op)=>{
                        op.removeAttribute('disabled');
                    })
                }
            })
        }

        function getVariantSelection(){
            const selections = []
            const variantSelectors = document.querySelectorAll('loess-variant-radios')

            variantSelectors.forEach((variant)=>{
                const inputs = variant.querySelectorAll('input');
                inputs.forEach((input)=>{
                    const isChecked = input.hasAttribute('checked')
                    const value = input.value;
                    const name = input.getAttribute('name');
                    if(isChecked){
                        selections.push({name,value})
                    }
                })
            })
            return selections
        }

        function updateInfos(){
            const selectedValues = getVariantSelection()
            let totalPrice = 0;
            matchingProducts = []
            bundleIds.forEach((id,index)=>{
                const matchingProduct = bundleProductsInfo.find((p)=>p.id == parseInt(id));
                if(matchingProduct){
                    const variants = matchingProduct.variants
                    let hasMatched = false
                    variants.forEach((variant)=>{
                        let matchingAllValues = true;
                        selectedValues.forEach((val)=>{
                            const productOptionIndex = matchingProduct.options.findIndex((op)=>op == val.name);
                            const variantOption = variant.options[productOptionIndex]
                            if(productOptionIndex >= 0 && variantOption !== val.value){
                                matchingAllValues = false;
                            }
                        })
                        if(matchingAllValues && !hasMatched){
                            hasMatched = true
                            totalPrice += variant.price;
                            matchingProducts.push(variant);
                            const image = images[index];
                            image.src = variant.featured_image ? variant.featured_image.src : ''
                        }
                    })
                }else{
                    const image = images[index];
                    image.src = ''
                }
            })

            const price = `${cartCurrencySymbol} ${formatMoney(totalPrice, shopMoney)}`;
            if(bundlePrice){
                bundlePrice.innerText = price;
            }
            if(bundlePriceDiscount){
                bundlePriceDiscount.innerText =`${cartCurrencySymbol} ${formatMoney(totalPrice * (100 - parseFloat(bundleDiscount)) / 100, shopMoney)}`;
            }
        }

    }



    function formatMoney (cents, format) {
        const money_format = "{{amount}}";
    
      if (typeof cents == 'string') { cents = cents.replace('.',''); }
      var value = '';
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var formatString = (format || money_format);
    
      function defaultOption(opt, def) {
         return (typeof opt == 'undefined' ? def : opt);
      }
    
      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ',');
        decimal   = defaultOption(decimal, '.');
    
        if (isNaN(number) || number == null) { return 0; }
    
        number = (number/100.0).toFixed(precision);
    
        var parts   = number.split('.'),
            dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
            cents   = parts[1] ? (decimal + parts[1]) : '';
    
        return dollars + cents;
      }
    
      switch(formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
      }
    
      return formatString.replace(placeholderRegex, value);
    };
    
}